module.exports = __webpack_public_path__ + "img/me-marker.30ab8c60.svg";